const host = 'https://sns.goloiov.cn/'
const config = {
  host
}
export default config



// WEBPACK FOOTER //
// ./src/utils/config.js